import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { TypeArea } from "./Styles";

export default function Type({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Tipo"
            value={!value ? document.type.description : value}
          />
        </div>
      ) : (
        <TypeArea>
          <Informative
            readonly={true}
            label="Tipo"
            value={!value ? document.type.description : value}
          />
        </TypeArea>
      )}
    </>
  );
}
